'use strict';

import {Dialog} from './dialog.js';

export class DialogChatwallpaper extends Dialog {
	constructor(component_key) {
		super(component_key);
	}

	init() {
		super.init();
		// Move the dialog out of the page column so its z-index competes globally
		// (the MC page column is a lower stacking context than the page header).
		if (this.$dialog.length && !this.$dialog.parent().is('body')) {
			this.$dialog.appendTo('body');
		}
	}

	on_show() {
		jQuery('html').addClass('js-no_scroll');
		setTimeout(() => {
			jQuery(`.js-${this.id}_position`).addClass('js-active');
		}, 50);
	}

	on_close() {
		jQuery(`.js-${this.id}_position`).removeClass('js-active');
		jQuery('html').removeClass('js-no_scroll');
	}
}